import axios from "axios";
import { toast } from "react-toastify";
import UserService from "../Services/user.service";

let authorizedAxiosInstance = axios.create();

authorizedAxiosInstance.defaults.baseURL = process.env.REACT_APP_SERVER_URL;

authorizedAxiosInstance.defaults.timeout = 10 * 60 * 1000; // 10 minutes

authorizedAxiosInstance.defaults.withCredentials = true;

authorizedAxiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let refreshTokenPromise = null;

authorizedAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      UserService.logOut().then((res) => {
        localStorage.removeItem("userInfo");
        toast.success(res?.message);
        window.location.href = "/";
      });
    }

    const originalRequest = error.config;

    if (error.response?.status === 410 && originalRequest) {
      if (!refreshTokenPromise) {
        refreshTokenPromise = UserService.refreshToken()
          .then(() => {})
          .catch((_error) => {
            UserService.logOut().then((res) => {
              localStorage.removeItem("userInfo");
              toast.success(res?.message);
              window.location.href = "/";
            });
            return Promise.reject(_error);
          })
          .finally(() => {
            refreshTokenPromise = null;
          });
      }

      return refreshTokenPromise.then(() => {
        return authorizedAxiosInstance(originalRequest);
      });
    }

    if (error.response?.status !== 410) {
      toast.error(error.response?.data?.message || error?.message);
    }

    return Promise.reject(error);
  }
);

export default authorizedAxiosInstance;
